export interface EmailLogParams {
  search?: string;
  row?: number;
  fetch?: number;
  fromDate?: number;
  toDate?: number;
}

export enum EMAIL_STATUS {
  PENDING = 'P',
  SENT = 'S',
}

export interface EmailLog {
  emailRequestedId: string;
  message: string;
  emailSentBy: string;
  emailSentTo: string;
  emailSentStatus: EMAIL_STATUS;
  createdOn: number;
}
